<template>
  <div class="fill-height">
    <template v-if="isArchivingEnabled">
      <router-view v-if="!configPending" v-slot="{ Component }">
        <transition name="app-fade">
          <component :is="Component" />
        </transition>
      </router-view>
      <div v-else class="d-flex align-center justify-center h-100">
        <v-progress-circular
          style="width: 64px; height: 64px"
          indeterminate
          color="primary"
          size="64"
        />
      </div>
    </template>
    <template v-else>
      <ArchivesPaywallDialog/>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { useArchivesStore } from '@/stores/archivesStore'

import ArchivesPaywallDialog from '../views/ArchivesPaywallDialog.vue'

export default {
  name: 'ArchivesLayout',
  components: {
    ArchivesPaywallDialog,
  },
  setup() {
    const archivesStore = useArchivesStore()
    return { archivesStore }
  },
  computed: {
    configPending() {
      return this.archivesStore.configPending
    },
    ...mapGetters('user', ['isArchivingEnabled']),
  },
  created () {
    if (this.isArchivingEnabled) {
      // This is always used, so we fetch it here
      this.archivesStore.getArchiveConfig()
    }
  },
}
</script>
